import {PortableText, PortableTextReactComponents} from '@portabletext/react';
import clsx from 'clsx';

import type {PortableTextBlock} from '~/types/sanityTypes';

import {
  ImageBlock,
  LinkEmailAnnotation,
  LinkExternalAnnotation,
  LinkInternalAnnotation,
} from '~/components';

export function PortableTextWrapper({
  blocks,
  className,
}: {
  blocks: PortableTextBlock[];
  className?: string;
}) {
  const underlineStyle = {textDecoration: 'underline'};

  const components: Partial<PortableTextReactComponents> = {
    block: {
      normal: ({children}) => <p className="pb-6">{children}</p>,
      blockquote: ({children}) => (
        <blockquote className="pb-6">{children}</blockquote>
      ),
      h1: ({children}) => <h1>{children}</h1>,
      h2: ({children}) => <h2>{children}</h2>,
      h3: ({children}) => <h3>{children}</h3>,
      h4: ({children}) => <h4>{children}</h4>,
      h5: ({children}) => <h5>{children}</h5>,
      h6: ({children}) => <h6>{children}</h6>,
    },
    marks: {
      em: ({children}) => <em>{children}</em>,
      strong: ({children}) => <strong>{children}</strong>,
      code: ({children}) => <code>{children}</code>,
      underline: ({children}) => <span style={underlineStyle}>{children}</span>,
      'strike-through': ({children}) => <del>{children}</del>,
      annotationLinkEmail: LinkEmailAnnotation,
      annotationLinkExternal: LinkExternalAnnotation,
      annotationLinkInternal: LinkInternalAnnotation,
    },
    list: {
      number: ({children}) => <ol className="pb-6">{children}</ol>,
      bullet: ({children}) => <ul className="pb-6">{children}</ul>,
    },
    types: {
      blockImage: ImageBlock,
    },
  };

  return (
    <div className={clsx(className, 'portableText')}>
      <PortableText components={components} value={blocks} />
    </div>
  );
}
